import { questionModalActionTypes } from './Constants';

export function setQuestionModal(data) {
	return {
		type: questionModalActionTypes.SET_QUESTION_MODAL,
		payload: { data },
	};
}

export function getAvailableSubjects() {
	return {
		type: questionModalActionTypes.GET_QUESTION_AVAILABLE_SUBJECTS,
	};
}

export function getAvailableSubjectsSuccess(data) {
	return {
		type: questionModalActionTypes.GET_QUESTION_AVAILABLE_SUBJECTS_SUCCESS,
		payload: { data },
	};
}

export function getAvailableSubjectsError(error) {
	return {
		type: questionModalActionTypes.GET_QUESTION_AVAILABLE_SUBJECTS_ERROR,
		payload: { error },
	};
}

export function getAvailableTopics(data) {
	return {
		type: questionModalActionTypes.GET_QUESTION_AVAILABLE_TOPICS,
		payload: { data },
	};
}

export function getAvailableTopicsSuccess(data) {
	return {
		type: questionModalActionTypes.GET_QUESTION_AVAILABLE_TOPICS_SUCCESS,
		payload: { data },
	};
}

export function getAvailableTopicsError() {
	return {
		type: questionModalActionTypes.GET_QUESTION_AVAILABLE_TOPICS_ERROR,
	};
}

export function clearAvailableTopics() {
	return {
		type: questionModalActionTypes.CLEAR_QUESTION_AVAILABLE_TOPICS,
	};
}

export function uploadImageRequest(file) {
	return {
		type: questionModalActionTypes.UPLOAD_QUESTION_ATTACHMENT_REQUEST,
		payload: {
			file,
		},
	};
}

export function uploadImageSuccess(publicLink, fileName) {
	return {
		type: questionModalActionTypes.UPLOAD_QUESTION_ATTACHMENT_SUCCESS,
		payload: {
			publicLink,
			fileName,
		},
	};
}

export function uploadImageError() {
	return {
		type: questionModalActionTypes.UPLOAD_QUESTION_ATTACHMENT_ERROR,
	};
}

export function createQuestionRequest(data) {
	return {
		type: questionModalActionTypes.CREATE_QUESTION_REQUEST,
		payload: {
			data,
		},
	};
}

export function createQuestionSuccess() {
	return {
		type: questionModalActionTypes.CREATE_QUESTION_SUCCESS,
		payload: {},
	};
}

export function createQuestionError() {
	return {
		type: questionModalActionTypes.CREATE_QUESTION_ERROR,
		error: true,
	};
}

export function updateQuestionRequest(data) {
	return {
		type: questionModalActionTypes.UPDATE_QUESTION_REQUEST,
		payload: {
			data,
		},
	};
}

export function updateQuestionSuccess() {
	return {
		type: questionModalActionTypes.UPDATE_QUESTION_SUCCESS,
		payload: {},
	};
}

export function updateQuestionError() {
	return {
		type: questionModalActionTypes.UPDATE_QUESTION_ERROR,
		error: true,
	};
}

export function clearQuestionState() {
	return {
		type: questionModalActionTypes.CLEAR_QUESTION_STATE,
	};
}
